import { atom } from 'jotai';

import {
    type FreeToSpendData,
    type FreeToSpendPeriod,
} from '../types/FreeToSpendTypes';

export const FreeToSpendPeriodAtom = atom<FreeToSpendPeriod>('monthly');
export const SelectedFreeToSpendAccountIndex = atom<number>(0);
export const SelectedFreeToSpendAccountSyncteraId = atom<string>('');
export const FreeToSpendSheetViewAtom = atom<'list' | 'details'>('list');
export const FreeToSpendDataAtom = atom<FreeToSpendData | null>(null);
